import {View} from "@lernetz/ts-lib";
import GoodPracticeModule from "../../../good-practice/good-practice.module";
import template from "./good-practice-details.component.html";

export class GoodPracticeDetails extends View {
    constructor() {
        super({ template, registry: GoodPracticeModule.views });
    }
}
